<template>
    <div class="public-content">
        <div class="public">
            <ChildSideBar></ChildSideBar>
            <div class="public-right">
                <TopBar></TopBar>
            </div>
        </div>
    </div>
</template>

<script>
    import ChildSideBar from '@/components/ChildSideBar.vue'
    import TopBar from '@/components/TopBar.vue'
    export default {
        name: "ChildPublic",
        components: {
            ChildSideBar,
            TopBar,
        },
    }
</script>

<style scoped>
    .public-content {
        height: 100%;
        z-index:5000;
    }
</style>